<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
        :newLayout="true"
        :hideFooter="false"
    >
        <template slot="card-header">
            <h1 v-translate>Getting Started</h1>
        </template>
        <template slot="card-body">
            <div class="row justify-content-center text-size-base my-3">
                <div class="col-md-8 text-center">
                    <div class="enrol-svg">
                        <svg-rndr svg="begin-enrol.svg" />
                    </div>
                    <p
                        class="text-standard mb-0"
                        v-translate
                    >Get set up in 5 minutes</p>
                </div>
            </div>
        </template>
        <template slot='card-footer'>
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>
            <div class="row align-items-center justify-content-end">
                <div class="col-md-6 text-center">
                    <router-link
                        :to="{ name: this.firstStage }"
                        class="btn btn-primary"
                        v-translate
                    >Start Enrolment</router-link>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import Card from '@C/Card.vue';
import EnrolmentMixin from '@M/enrolment';
import { getRouteFromStageName } from '@H/enrolment';

export default {
    name: 'BeginEnrolment',
    computed: {
        /**
         * Get the vue route name for the step that the authenticated user should start at
         * Defaults to the personal information (1st) stage
         */
        firstStage() {
            let usersStage = this.user.profile.current_stage;

            if (typeof usersStage == 'undefined' || usersStage === null) {
                return 'enrolment-personal';
            }

            return getRouteFromStageName(usersStage);
        }
    },
    components: {
        Card
    },
    mixins: [EnrolmentMixin]
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Enrolment/Begin.vue